import { render, staticRenderFns } from "./BusinessTypeDropdown.vue?vue&type=template&id=255631f8&"
import script from "./BusinessTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports